import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavService, Menu, Menu1 } from '../../services/nav.service';
import { AESService } from 'src/app/APIservices/encryption/aes.service';
import { LoginService } from 'src/app/APIservices/registration/login.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {

  public menuItems: Menu[]
  public menuItems1: Menu1[];
  public url: any;
  public fileurl: any;
  role: any;
  permissions: any = {};
  obj: any = {}
  constructor(private logindata: LoginService, private aes: AESService, private router: Router, public navServices: NavService) {
    this.role = this.aes.getItem('role', true)
    let per: any = JSON.parse(this.aes.getItem('permissions', true))
    // console.log(per);
    this.permissions = per
    console.log(this.permissions, '<<<')
    //   this.logindata.getpermissions().subscribe((res)=>{
    //  console.log(res);
    //  this.permissions=res
    //  });


    if (this.role?.toLocaleLowerCase() == 'admin') {
      this.navServices.items.subscribe(menuItems => {
        this.menuItems = menuItems

        this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
            menuItems.filter(items => {
              if (items.path === event.url)
                this.setNavActive(items)
              if (!items.children) return false
              items.children.filter(subItems => {
                if (subItems.path === event.url)
                  this.setNavActive(subItems)
                if (!subItems.children) return false
                subItems.children.filter(subSubItems => {
                  if (subSubItems.path === event.url)
                    this.setNavActive(subSubItems)
                })
              })
            })
          }
        })
      })
    } else {
      this.navServices.items1.subscribe(menuItems => {
        let marray = [];
        let arr = Object.keys(this.permissions);
        for (let key of arr) {
          //           if(key != "useredit"){
          //             console.log('e');

          // menuItems[1].children.splice(1,1)
          //           }
          for (let action of menuItems) {

            if (action.matchingaction == key) {

              marray.push(action)
              this.menuItems = marray

            }


          }
        }
        //  this.menuItems1 = menuItems
        this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
            this.menuItems?.filter(items => {
              if (items.path === event.url)
                this.setNavActive(items)
              if (!items.children) return false
              items.children.filter(subItems => {
                if (subItems.path === event.url)
                  this.setNavActive(subItems)
                if (!subItems.children) return false
                subItems.children.filter(subSubItems => {
                  if (subSubItems.path === event.url)
                    this.setNavActive(subSubItems)
                })
              })
            })
          }
        })
      })

    }
  }

  // Active Nave state
  setNavActive(item) {
    this.menuItems.filter(menuItem => {
      if (menuItem != item)
        menuItem.active = false
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true
            submenuItems.active = true
          }
        })
      }
    })
  }

  collapseSidebar() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar
  }
  // Click Toggle menu
  toggletNavActive(item) {
    if (!item.active) {
      this.menuItems.forEach(a => {
        if (this.menuItems.includes(item))
          a.active = false
        if (!a.children) return false
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false
          }
        })
      });
    }
    item.active = !item.active
  }

  //Fileupload
  readUrl(event: any) {
    if (event.target.files.length === 0)
      return;
    //Image upload validation
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.url = reader.result;
    }
  }

}
